module.exports = __webpack_public_path__ + "img/product-preview-11.194f285.png";